import React from "react"

import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import {ConditionType} from "../../../../../model2/conditions/condition-types"
import FieldProto from "../../../../proto/field-proto"
import FieldFormElementView from "../../../../render/form-elemnent-view"
import FieldsFactory from "../../../../fields-factory"
import {FieldType} from "../../../../field-type"

// const debug = "FieldDate_ConditionForm"
const debug = false

export default class FieldDate_ConditionForm extends FieldProto_ConditionForm {
    render() {
        debug && console.log(debug, 'render', this.props.condition.type, this.state)

        let valueField : FieldProto | null = null

        switch (this.props.condition.type) {
            case ConditionType.DATE_RELATIVE_EQUALS:
            case ConditionType.DATE_RELATIVE_BEFORE:
            case ConditionType.DATE_RELATIVE_AFTER:
                valueField = FieldsFactory.get({
                    type    : FieldType.DATE_RELATIVE,
                    fieldId : 'value'
                })

                if (!this.props.condition.value) this.props.condition.value = 0 // Today

                break

            case ConditionType.DATE_RELATIVE_RANGE:
                valueField = FieldsFactory.get({
                    type    : FieldType.DATE_RANGE_RELATIVE,
                    fieldId : 'value'
                })

                if (!this.props.condition.value) this.props.condition.value = { start: 0, end: 0 } // Today - Today

                break

            case ConditionType.DATE_RELATIVE_PERIOD:
                valueField = FieldsFactory.get({
                    type    : FieldType.DATE_RANGE_RELATIVE_PERIOD,
                    fieldId : 'value'
                })

                break

            case ConditionType.DATE_FIXED_EQUALS:
            case ConditionType.DATE_FIXED_AFTER:
            case ConditionType.DATE_FIXED_BEFORE:
                valueField = FieldsFactory.get({
                    type        : FieldType.DATE,
                    fieldId     : 'value',
                    clearButton : false
                })

                if (!this.props.condition.value) this.props.condition.value = moment()
                break

            case ConditionType.DATE_FIXED_RANGE:
                valueField = FieldsFactory.get({
                    type        : FieldType.DATE_RANGE,
                    fieldId     : 'value',
                    clearButton : false
                })

                // if (!this.props.condition.value) this.props.condition.value = moment()
                break


            default:
                console.warn("FieldDate_ConditionForm: unknown condition type for value", this.props.condition.type)
        }


        return (
            <>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                {valueField &&
                    <FieldFormElementView className = "fl-no-shrink w-250 m-l-10"
                                          field     = {valueField}
                                          model     = {this.props.condition}
                                          onChange  = {this.onChangeValue}/> }
            </>
        )
    }
}